import React, { useEffect, useState } from 'react';
import Cookies from 'react-cookies';
import { useDispatch, useSelector } from 'react-redux';
import { COOKIES, LOCATION_SELECTED } from '../../brands/default/constants';
import { HEADER_LOCATION } from '../../brands/default/content/components/header';
import { setLocation } from '../../redux/actions/locations';
import HeaderIcon from './HeaderIcon';
import HeaderLocationDropDown from './HeaderLocationDropDown';

const HeaderLocation = () => {
  const [location] = useSelector((state) => [state.locations.location]);
  const hasSelection =
    typeof window === 'undefined'
      ? {}
      : localStorage.getItem(LOCATION_SELECTED);
  const lightboxLocation = Cookies.load(COOKIES.lightboxLocation);

  const locationObject = location || lightboxLocation;
  const locationName = locationObject?.shortName;
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);

  const onClickIcon = (show) => {
    setShowModal(show);
  };
  useEffect(() => {
    if (lightboxLocation && hasSelection !== 'set') {
      dispatch(setLocation(locationObject, true));
    }
  }, [locationName]);

  return (
    <>
      <HeaderLocationDropDown
        setShowModal={setShowModal}
        showModal={showModal}
      />

      <HeaderIcon
        aria-label={HEADER_LOCATION.changeLocation}
        clickMethod={() => onClickIcon(true)}
        extraClasses="with-fade-in"
        icon="location"
        isFirst
        linkId="id-choose-loc"
      />
    </>
  );
};

HeaderLocation.propTypes = {};

export default HeaderLocation;
